import { createRouter, createWebHistory } from "vue-router";
import HomePage from "../pages/HomePage.vue";
import NewsList from "@/pages/news/NewsList.vue";
import NewsDetail from "@/pages/news/NewsDetail.vue";

const routes = [
  { path: "/", name: "Home", component: HomePage },

  // กลุ่มผลิตภัณฑ์ (Products)
  {
    path: "/products/life",
    name: "LifeInsurance",
    component: () => import("../pages/products/LifeInsurance.vue"),
  },
  {
    path: "/products/health",
    name: "HealthInsurance",
    component: () => import("../pages/products/HealthInsurance.vue"),
  },
  {
    path: "/products/accident",
    name: "AccidentInsurance",
    component: () => import("../pages/products/AccidentInsurance.vue"),
  },

  {
    path: "/products/accident/:slug",
    name: "accident-insurance-detail",
    component: () => import("../pages/products/ProductDetails.vue"),
    props: true,
  },

  {
    path: "/products/life/:slug",
    name: "life-insurance-detail",
    component: () => import("../pages/products/ProductDetails.vue"),
    props: true,
  },

  {
    path: "/products/health/:slug",
    name: "health-insurance-detail",
    component: () => import("../pages/products/ProductDetails.vue"),
    props: true,
  },

  // ข่าวสาร
  {
    path: "/news",
    name: "News",
    component: () => import("../pages/NewsPage.vue"),
  },
  // 1. Route ที่ fixed path ก่อน
  {
    path: "/news/list",
    name: "NewsList",
    component: NewsList,
  },

  // 2. Route ที่ dynamic (:slug) ไว้ท้ายสุด
  {
    path: "/news/:slug",
    name: "NewsDetail",
    component: NewsDetail,
    props: true,
  },

  // เกี่ยวกับเรา
  {
    path: "/about",
    name: "About",
    component: () => import("../pages/AboutPage.vue"),
  },

  // กลุ่มร่วมงาน (Careers)
  {
    path: "/careers/jobs",
    name: "OpenPositions",
    component: () => import("../pages/careers/OpenPositions.vue"),
  },
  {
    path: "/careers/agent",
    name: "AgentApply",
    component: () => import("../pages/careers/AgentApply.vue"),
  },

  // ติดต่อเรา
  {
    path: "/contact",
    name: "Contact",
    component: () => import("../pages/ContactPage.vue"),
  },

  // บทความ
  {
    path: "/articles",
    name: "Articles",
    component: () => import("../pages/ArticlesPage.vue"),
  },
  {
    path: "/articleList",
    name: "articlesList",
    component: () => import("../pages/Article/ArticlesList.vue"),
  },
  {
    path: "/articles/:id",
    name: "ArticleDetail",
    component: () => import("../pages/Article/ArticlesDetail.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0 };
  },
});

export default router;
